<template>
  <v-row

    align="center"
    style="cursor: pointer;">
    <v-col>
      <div class="text-center black--text">
        <v-btn
          text
          icon
          large
          class="ma-0">
          <v-badge
            color="red"
            overlap>
            <span
              slot="badge"
              v-if="typeof unreadCounts[menuItem] !== 'undefined' && unreadCounts[menuItem].count > 0">{{ unreadCounts[menuItem].count }}</span>
            <v-icon
              large
              :color="settings.colour">{{ settings.icon }}</v-icon>
          </v-badge>
        </v-btn>
        <div
          class="text-center black--text"
          v-if="typeof customMenuNames[menuItem] !== 'undefined'">{{ customMenuNames[menuItem] }}</div>
        <div
          class="text-center black--text"
          v-else>{{ menuItem }}</div>

      </div>

    </v-col>

  </v-row>
</template>

<script>
export default {
  props: {
    menuItem: {
      type: String,
      default: ''
    },
    settings: {
      type: Object,
      default () {
        return {}
      }
    },
    customMenuNames: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    unreadCounts: function () { return this.$store.state.unreadCounts }
  }
}
</script>
